
import { http } from "./http";

const ENDPOINTS = {
  USERS: "/users/",
  USER: (id) => `/users/${id}/`,
  USER_PROFILE: "/users/profile/",
  USER_PASSWORD_RESET: (id) => `/users/${id}/password_reset/`,
};

export const userAPI = {
  getAll: () => http.get(ENDPOINTS.USERS),
  getById: (id) => http.get(ENDPOINTS.USER(id)),
  create: (userData) => http.post(ENDPOINTS.USERS, userData),
  update: (id, userData) => http.patch(ENDPOINTS.USER(id), userData),
  delete: (id) => http.delete(ENDPOINTS.USER(id)),
  getProfile: () => http.get(ENDPOINTS.USER_PROFILE),
  updateProfile: (data) => http.put(ENDPOINTS.USER_PROFILE, data),
  changePassword: (id, data) => http.post(ENDPOINTS.USER_PASSWORD_RESET(id), data),
};